export const ReturnToWorkReasons = [
    { value: 'Not returning to work', label: 'Not returning to work' },
    { value: 'Medically boarded', label: 'Medically boarded' },
    { value: 'Return to work date unknown', label: 'Return to work date unknown' },
];
